export default __webpack_public_path__ + "static/media/mssymbol.42b61fa1.svg";